
    export default {
      mounted() {
        this.label = this.el.querySelector(".js-copy-label")
        this.defaultLabel = this.label.textContent
        this.el.addEventListener("click", () => this.copy())
      },

      async copy() {
        try {
          await navigator.clipboard.writeText(this.el.dataset.copyText)
          this.announce(this.el.dataset.copiedLabel)
        } catch (_error) {
          // Clipboard-API nicht verfuegbar/verweigert: der Link bleibt als
          // Text markierbar, kein Fallback noetig.
        }
      },

      announce(text) {
        clearTimeout(this.resetTimer)
        this.label.textContent = text
        this.resetTimer = setTimeout(() => (this.label.textContent = this.defaultLabel), 1600)
      },

      destroyed() {
        clearTimeout(this.resetTimer)
      }
    }
  